import { combineReducers } from "redux";
import { userProfile } from "./authReducers.js";
import { users } from "./usersReducer";
import { userTypes } from "../constantes/actionTypes";
import { rolesList } from "./rolesReducers";
import { positions } from "./positionsReducers";
import { departaments } from "./departamentsReducers";
import { specialties } from "./specialtiesReducers";
import { hospitals } from "./hospitalsReducers";
import { businessunits } from "./businessunitsReducers";
import { eventos } from "./eventosReducers";

import { zones } from "./zonesReducers";
import { colors } from "./colorsReducers";
import { articles } from "./articlesReducers";
import { tasks } from "./tasksReducers";
import { contacts } from "./contactsReducers";
import { events } from "./eventsReducers";
import { phases } from "./phasesReducers";
import { categories } from "./categoriesReducers";
import { typesOfDocuments } from "./typesOfDocumentsReducers";
import { presentations } from "./presentationsReducers";
import { hospitalsContacts } from "./hospitalsContactsReducers";
import { timeSlots } from "./timeSlotsReducers";
import { productsContactPresentation } from "./accessToPresentationByContact/productsContactPresentationReducers";
import { infoProfileContactHospitalPresentation } from "./accessToPresentationByContact/infoProfileContactHospitalPresentationReducers";
import { TOKEN_KEY } from "../constantes/localStorageKeys.js";
import { communities } from "./communitiesReducers.js";

const appReducer = combineReducers({
  userProfile,
  users,
  rolesList,
  colors,
  businessunits,
  eventos,
  zones,
  positions,
  departaments,
  specialties,
  hospitals,
  articles,
  tasks,
  contacts,
  events,
  phases,
  categories,
  typesOfDocuments,
  presentations,
  hospitalsContacts,
  timeSlots,
  infoProfileContactHospitalPresentation,
  productsContactPresentation,
  communities,
});

const rootReducer = (state, action) => {
  // Si hacem logout borramos tada la info de localstorge
  if (action.type === userTypes.LOGOUT) {
    state = undefined;
  }
  if (action.payload === 401) {
    //swalAlertError("Token invalido, vuelve a autentificarse ")
    //authApi.logout()
    localStorage.removeItem(TOKEN_KEY);
    //localStorage.removeItem("persist:root")
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
